/**
 * Creates an object composed of the own and inherited enumerable property paths of object that are not omitted
 *
 * @param {Object} obj - The source object.
 * @param {String[]} keys - The keys path to omit.
 * @return {Object} The new object.
 */
export const omit = <T = object>(obj: T, keys: (keyof T)[]): Omit<T, keyof T> =>
  Object.fromEntries(Object.entries(obj).filter(([k]) => !keys.includes(k as keyof T))) as Omit<T, keyof T>;
